import axios from "./axios-instance"
import store from "@/store"

export default {
  edilexAuthenticate: payload => axios(store)({
    url: "/api/edilex/login",
    method: "POST",
    data: payload,
  }),
  edilexLogout: () => axios(store)({
    url: "/api/edilex/logout",
    method: "POST",
  }),
  webshopAuthenticate: payload => axios(store)({
    url: "/api/webshop/login",
    method: "POST",
    data: payload,
  }),
  webshopLogout: () => axios(store)({
    url: "/api/webshop/logout",
    method: "POST",
  }),
  whoami: () => axios(store)({
    url: "/api/auth/whoami",
    method: "GET",
  }),
}
